import { Box } from "@mui/material";
import React from "react";
import UserDepositsConnections from "./UserDepositsConnections.component";


const UserDeposits=({ userId }) => {
    return (
        <Box>
            <UserDepositsConnections userId={userId} />
        </Box>
    );
}

export default UserDeposits;